import { Component, Input } from '@angular/core';

/**
 * One step in a breadcrumb trail.
 *
 * A step with no link renders as plain text, which is what a section that has
 * no page of its own (or one the current user may not open) should look like.
 */
export interface Breadcrumb {
  label: string;
  /** Router path: '/clients/list', or ['/clients/details', id]. */
  link?: string | any[];
  /** Font Awesome 4 suffix, e.g. 'users' for fa-users. */
  icon?: string;
}

/**
 * The trail under a page title.
 *
 * Every page in the app hangs off the dashboard, so Dashboard is prepended
 * here rather than repeated by each caller; pages pass only the steps below
 * it. The last step is the page itself and is never a link, so the same trail
 * can be built without special-casing the end of it.
 */
@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss'],
})
export class BreadcrumbsComponent {
  @Input() items: Breadcrumb[] = [];

  /** Off for the dashboard itself, which would otherwise link to itself. */
  @Input() home = true;

  /** A step is a link only when it has somewhere to go and is not the page we are on. */
  isLink(item: Breadcrumb, last: boolean): boolean {
    return !!item.link && !last;
  }
}
